import { IPagePrimaryElement, WidgetPlaceType } from "./index";
import { IAnimatedWidget } from "./widget-style-data";

export interface IStoreSubscriptionDetailsWidgetData extends IPagePrimaryElement {
    readonly type: "StoreSubscriptionDetailsWidget";
    placeType: WidgetPlaceType;
    id?: string | null;
    style: IStoreSubscriptionDetailsWidgetStyle;
    subscriptionDataBase64?: string;
}

export type IStoreSubscriptionDetailsWidgetStyle = IAnimatedWidget

export abstract class StoreSubscriptionDetailsWidgetData {

    public static get defaultData(): IStoreSubscriptionDetailsWidgetData {
        return {
            type: "StoreSubscriptionDetailsWidget",
            placeType: "Section",
            primaryElement: true,
            style: this.defaultStyle
        };
    }

    public static get defaultStyle(): IStoreSubscriptionDetailsWidgetStyle {
        return {
            animation: {
                animationSource: "site-design",
                animationData: {
                    name: "none",
                    duration: 1
                }
            }
        };
    }

    public static isLocalScriptRerenderNeeded(leftHandSide?: IStoreSubscriptionDetailsWidgetData, rightHandSide?: IStoreSubscriptionDetailsWidgetData): boolean {
        return leftHandSide?.id === rightHandSide?.id;
    }

}